(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bugmd-presell-reasons"] && !Shopify.designMode) return;
  try {
    
/* Lazy-load reason videos — defer fetch until 200px from viewport.
   Falls back to animated AVIF on iOS Low Power Mode (NotAllowedError). */
(function () {
  var videos = document.querySelectorAll('.presell-reasons video.lazy-video');
  if (!videos.length) return;
  var io;

  function swapToAnimatedImage(v) {
    if (v.dataset.swapped) return;
    v.dataset.swapped = '1';
    if (io) io.unobserve(v);
    var img = document.createElement('img');
    img.className = 'lazy-video';
    img.src = v.dataset.poster || v.poster || '';
    img.alt = 'Product demo ' + v.dataset.reason;
    img.width = 600;
    img.height = 600;
    img.decoding = 'async';
    img.style.objectFit = 'cover';
    v.parentNode.replaceChild(img, v);
  }

  function activate(v) {
    if (v.dataset.swapped) return;
    if (!v.poster && v.dataset.poster) v.poster = v.dataset.poster;
    if (!v.src && v.dataset.src) v.src = v.dataset.src;
    var p = v.play();
    if (p && p.catch) {
      p.catch(function (err) {
        if (err && err.name === 'NotAllowedError') swapToAnimatedImage(v);
      });
    }
  }

  if (!('IntersectionObserver' in window)) {
    videos.forEach(activate);
    return;
  }

  io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target;
      if (entry.isIntersecting) activate(v);
      else { try { v.pause(); } catch (e) {} }
    });
  }, { rootMargin: '200px 0px' });

  videos.forEach(function (v) { io.observe(v); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bugmd-presell-sale-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  var banner = document.getElementById('presell-sale-banner');
  if (!banner) return;

  var KEY = 'presellCountdownEnd';
  var hrs = parseInt(banner.dataset.cdHours || '2', 10);
  var min = parseInt(banner.dataset.cdMinutes || '12', 10);
  var DURATION_MS = (hrs * 3600 + min * 60) * 1000;

  var endAt = parseInt(localStorage.getItem(KEY) || '0', 10);
  var now = Date.now();
  if (!endAt || endAt <= now) {
    endAt = now + DURATION_MS;
    localStorage.setItem(KEY, String(endAt));
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    var diff = Math.max(0, Math.floor((endAt - Date.now()) / 1000));
    var h = Math.floor(diff / 3600);
    var m = Math.floor((diff % 3600) / 60);
    var s = diff % 60;
    var hEl = document.getElementById('cu-hrs');
    var mEl = document.getElementById('cu-min');
    var sEl = document.getElementById('cu-sec');
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
  }
  tick();
  setInterval(tick, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petlab-faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* Scope each FAQ section independently so multiple FAQs on one page
       don't control each other's open/close state. */
    var sections = document.querySelectorAll('.petlab-faq[data-section-id]');

    sections.forEach(function(section) {
      var triggers = section.querySelectorAll('.petlab-faq__trigger');

      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          var expanded = this.getAttribute('aria-expanded') === 'true';
          var contentId = this.getAttribute('aria-controls');
          var content = document.getElementById(contentId);

          /* Close all other items WITHIN THIS SECTION only */
          triggers.forEach(function(otherTrigger) {
            if (otherTrigger !== trigger) {
              otherTrigger.setAttribute('aria-expanded', 'false');
              var otherId = otherTrigger.getAttribute('aria-controls');
              var otherContent = document.getElementById(otherId);
              if (otherContent) {
                otherContent.style.maxHeight = '0';
                otherContent.classList.remove('petlab-faq__content--open');
              }
            }
          });

          /* Toggle current */
          if (expanded) {
            this.setAttribute('aria-expanded', 'false');
            content.style.maxHeight = '0';
            content.classList.remove('petlab-faq__content--open');
          } else {
            this.setAttribute('aria-expanded', 'true');
            /* Use scrollHeight but also set to 'none' after transition so
               dynamically-grown content (images loading, etc.) stays visible */
            content.style.maxHeight = content.scrollHeight + 'px';
            content.classList.add('petlab-faq__content--open');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petlab-info-accordion"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.petlab-info-accordion');
    sections.forEach(function(section) {
      var triggers = section.querySelectorAll('[data-accordion-trigger]');
      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          var expanded = trigger.getAttribute('aria-expanded') === 'true';
          var contentId = trigger.getAttribute('aria-controls');
          var content = document.getElementById(contentId);
          if (!content) return;
          if (expanded) {
            trigger.setAttribute('aria-expanded', 'false');
            content.setAttribute('hidden', '');
          } else {
            trigger.setAttribute('aria-expanded', 'true');
            content.removeAttribute('hidden');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petlab-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var carousels = document.querySelectorAll('[id^="petlab-carousel-"]');

    carousels.forEach(function(carousel) {
      var slidesContainer = carousel.querySelector('[data-slides]');
      var dotsContainer = carousel.querySelector('[data-dots]');
      var prevBtn = carousel.querySelector('[data-prev]');
      var nextBtn = carousel.querySelector('[data-next]');

      if (!slidesContainer) return;

      var slides = slidesContainer.querySelectorAll('.petlab-carousel__slide');
      var totalSlides = slides.length;
      if (totalSlides === 0) return;

      var currentSlide = 0;

      function goToSlide(index) {
        currentSlide = index;
        /* Use the slide's own offsetLeft so the gap between slides is
           automatically accounted for — no manual math needed. */
        var targetSlide = slides[index];
        if (targetSlide) {
          slidesContainer.style.transform = 'translateX(-' + targetSlide.offsetLeft + 'px)';
        }
        if (dotsContainer) {
          var dots = dotsContainer.querySelectorAll('.petlab-carousel__dot');
          dots.forEach(function(d, i) {
            d.classList.toggle('petlab-carousel__dot--active', i === index);
          });
        }
      }

      /* Build dots (only if more than 1 slide) */
      if (dotsContainer && totalSlides > 1) {
        for (var i = 0; i < totalSlides; i++) {
          (function(index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'petlab-carousel__dot' + (index === 0 ? ' petlab-carousel__dot--active' : '');
            dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
            dot.addEventListener('click', function() { goToSlide(index); });
            dotsContainer.appendChild(dot);
          })(i);
        }
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          goToSlide((currentSlide - 1 + totalSlides) % totalSlides);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          goToSlide((currentSlide + 1) % totalSlides);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petlab-product-selector-nosub"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* ============ Product Image Carousel ============ */
    var pdpCarousels = document.querySelectorAll('[id^="petlab3-pdp-carousel-"]');
    pdpCarousels.forEach(function(carousel) {
      var slidesContainer = carousel.querySelector('[data-pdp3-carousel-slides]');
      if (!slidesContainer) return;
      var slides = slidesContainer.querySelectorAll('.petlab3-pdp__carousel-slide');
      var totalSlides = slides.length;
      if (totalSlides <= 1) return;

      var currentSlide = 0;
      var progressFill = carousel.querySelector('[data-pdp3-carousel-progress-fill]');
      var thumbButtons = carousel.querySelectorAll('.petlab3-pdp__carousel-thumb');
      var thumbsContainer = carousel.querySelector('[data-pdp3-carousel-thumbs]');
      var thumbPrev = carousel.querySelector('[data-pdp3-thumb-prev]');
      var thumbNext = carousel.querySelector('[data-pdp3-thumb-next]');
      var desktopMq = window.matchMedia('(min-width: 768px)');

      /* Desktop: navigate main image via translateX */
      var thumbOffset = 0;
      var thumbsPerView = 4;

      function updateThumbView() {
        if (!thumbsContainer) return;
        var thumbEls = thumbsContainer.querySelectorAll('.petlab3-pdp__carousel-thumb');
        if (thumbEls.length === 0) return;
        var thumbWidth = thumbEls[0].offsetWidth + 6;
        thumbsContainer.scrollTo({ left: thumbOffset * thumbWidth, behavior: 'smooth' });
      }

      function goToSlide(index) {
        if (index < 0) index = 0;
        if (index >= totalSlides) index = totalSlides - 1;
        currentSlide = index;
        slidesContainer.style.transition = 'transform .45s cubic-bezier(.4,0,.2,1)';
        slidesContainer.style.transform = 'translateX(-' + (index * 100) + '%)';
        thumbButtons.forEach(function(thumb, i) {
          thumb.classList.toggle('petlab3-pdp__carousel-thumb--active', i === index);
        });
        /* Keep active thumb in the visible window of 4 */
        if (index < thumbOffset) {
          thumbOffset = index;
          updateThumbView();
        } else if (index >= thumbOffset + thumbsPerView) {
          thumbOffset = index - thumbsPerView + 1;
          updateThumbView();
        }
      }

      /* Thumbnail click handlers */
      thumbButtons.forEach(function(thumb, i) {
        thumb.addEventListener('click', function() { goToSlide(i); });
      });

      /* Thumbnail strip arrow handlers — shift visible thumbnails + navigate main image */
      if (thumbPrev) {
        thumbPrev.addEventListener('click', function() {
          if (thumbOffset > 0) {
            thumbOffset--;
            updateThumbView();
          }
          if (currentSlide > 0) goToSlide(currentSlide - 1);
        });
      }
      if (thumbNext) {
        thumbNext.addEventListener('click', function() {
          if (thumbOffset < totalSlides - thumbsPerView) {
            thumbOffset++;
            updateThumbView();
          }
          if (currentSlide < totalSlides - 1) goToSlide(currentSlide + 1);
        });
      }

      /* Mobile: progress bar — poll scroll position (reliable across all browsers) */
      if (progressFill) {
        setInterval(function() {
          if (desktopMq.matches) return;
          var sw = slidesContainer.scrollWidth;
          var cw = slidesContainer.clientWidth;
          if (sw <= cw) return;
          var p = (slidesContainer.scrollLeft + cw) / sw;
          progressFill.style.transform = 'scaleX(' + Math.min(Math.max(p, 0), 1) + ')';
        }, 100);
      }

      /* Handle resize between mobile ↔ desktop */
      function handleResize() {
        if (desktopMq.matches) {
          slidesContainer.scrollLeft = 0;
          goToSlide(currentSlide);
        } else {
          slidesContainer.style.transform = '';
        }
      }
      if (desktopMq.addEventListener) { desktopMq.addEventListener('change', handleResize); }
      else if (desktopMq.addListener) { desktopMq.addListener(handleResize); }

      /* Desktop: swipe on main image */
      var deskTouchStartX = 0;
      slidesContainer.addEventListener('touchstart', function(e) {
        if (desktopMq.matches) deskTouchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      slidesContainer.addEventListener('touchend', function(e) {
        if (!desktopMq.matches) return;
        var diff = deskTouchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) goToSlide(currentSlide + 1);
          else goToSlide(currentSlide - 1);
        }
      });

      /* Initial state */
      if (desktopMq.matches) { goToSlide(0); }
    });

    /* ============ Size Buttons ============ */
    var sizeButtons = document.querySelectorAll('.petlab3-pdp__size-btn');
    var sizeIndexToQuantity = [1, 2, 3];

    sizeButtons.forEach(function(btn, sizeIndex) {
      btn.addEventListener('click', function() {
        sizeButtons.forEach(function(b) { b.classList.remove('petlab3-pdp__size-btn--active'); });
        this.classList.add('petlab3-pdp__size-btn--active');
        var targetQty = sizeIndexToQuantity[sizeIndex];
        if (targetQty == null) return;
        var targetCard = document.querySelector('.petlab3-pdp__qty-card[data-line-item-quantity="' + targetQty + '"]');
        if (targetCard) targetCard.click();
      });
    });

    /* Auto-click the Liquid-selected default size AFTER handlers are bound */
    var defaultSizeBtn = document.querySelector('.petlab3-pdp__size-btn--active');
    if (defaultSizeBtn) defaultSizeBtn.click();

    /* ============ Size / Quantity Logic ============ */
    var infoWrapper = document.getElementById('petlab3-pdp-info');
    var quantityInput = document.getElementById('petlab3-line-quantity');

    /* ============ Quantity card selection ============ */
    var qtyCards = document.querySelectorAll('.petlab3-pdp__qty-card');
    qtyCards.forEach(function(card) {
      card.addEventListener('click', function() {
        qtyCards.forEach(function(c) {
          c.classList.remove('petlab3-pdp__qty-card--selected');
          var radio = c.querySelector('.petlab3-pdp__radio-outer');
          if (radio) { radio.classList.remove('petlab3-pdp__radio-outer--checked'); radio.innerHTML = ''; }
        });
        this.classList.add('petlab3-pdp__qty-card--selected');
        var radio = this.querySelector('.petlab3-pdp__radio-outer');
        if (radio) { radio.classList.add('petlab3-pdp__radio-outer--checked'); radio.innerHTML = '<div class="petlab3-pdp__radio-inner"></div>'; }
        if (quantityInput) {
          var q = parseInt(this.getAttribute('data-line-item-quantity'), 10);
          if (!isNaN(q) && q > 0) quantityInput.value = q;
        }
      });
    });

    /* ============ Add to Cart Handler ============ */
    var productForm = document.getElementById('petlab3-product-form');
    var atcButton = document.getElementById('petlab3-add-to-cart');

    /* Theme class stripper */
    function stripThemeClasses() {
      if (!atcButton) return;
      var keep = [];
      var classes = atcButton.className.split(/\s+/);
      for (var i = 0; i < classes.length; i++) { var cls = classes[i]; if (cls && cls.indexOf('petlab3-') === 0) keep.push(cls); }
      var newClassName = keep.join(' ');
      if (atcButton.className !== newClassName) atcButton.className = newClassName;
    }
    stripThemeClasses();
    if (atcButton && typeof MutationObserver !== 'undefined') {
      var classObserver = new MutationObserver(function(mutations) { for (var i = 0; i < mutations.length; i++) { if (mutations[i].attributeName === 'class') { stripThemeClasses(); break; } } });
      classObserver.observe(atcButton, { attributes: true, attributeFilter: ['class'] });
    }

    var atcLabel = productForm ? productForm.querySelector('.petlab3-pdp__atc-label') : null;
    var atcSpinner = productForm ? productForm.querySelector('.petlab3-pdp__atc-spinner') : null;
    var atcError = document.getElementById('petlab3-atc-error');
    var variantInput = document.getElementById('petlab3-variant-id');

    function setAtcLoading(isLoading) {
      if (!atcButton) return;
      atcButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      atcButton.disabled = !!isLoading;
      var idleLabel = atcButton.getAttribute('data-atc-idle-label') || 'Add to Cart';
      if (atcLabel) atcLabel.textContent = isLoading ? 'Adding...' : idleLabel;
      if (atcSpinner) { if (isLoading) atcSpinner.removeAttribute('hidden'); else atcSpinner.setAttribute('hidden', ''); }
    }
    function showAtcError(message) { if (!atcError) return; atcError.textContent = message; atcError.removeAttribute('hidden'); }
    function clearAtcError() { if (!atcError) return; atcError.setAttribute('hidden', ''); atcError.textContent = ''; }

    /* bfcache restoration */
    window.addEventListener('pageshow', function(event) { if (event.persisted) { setAtcLoading(false); clearAtcError(); } });

    if (productForm) {
      productForm.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        clearAtcError();

        var selectedCard = document.querySelector('.petlab3-pdp__qty-card--selected');
        var lineQuantity = 1;
        if (selectedCard) { var q = parseInt(selectedCard.getAttribute('data-line-item-quantity'), 10); if (!isNaN(q) && q > 0) lineQuantity = q; }

        var variantId = variantInput ? variantInput.value : '';

        if (!variantId) { showAtcError('Product is not configured. Please contact support.'); return; }

        /* Build Kaching-compatible cart payload */
        var kachingDeal = infoWrapper ? infoWrapper.getAttribute('data-kaching-deal') : '';
        var kachingBidByQty = {
          1: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-1') : '',
          2: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-2') : '',
          3: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-3') : ''
        };
        var giftShippingId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-shipping') : '';
        var giftEbookId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-ebook') : '';
        var giftMysteryId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-mystery') : '';
        var shippingVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-shipping') : '';
        var ebookVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-ebook') : '';
        var mysteryVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-mystery') : '';

        function generateBundleInstanceId() {
          var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
          var out = '';
          for (var i = 0; i < 4; i++) out += chars.charAt(Math.floor(Math.random() * chars.length));
          return out;
        }
        var bundleInstanceId = generateBundleInstanceId();
        var mainBid = kachingBidByQty[lineQuantity] || kachingBidByQty[1];

        function buildGiftItem(giftVariantId, giftId) {
          var kachingMeta = { id: bundleInstanceId, deal: kachingDeal, gift: giftId };
          var item = { id: giftVariantId, quantity: 1, parent_id: parseInt(variantId, 10), properties: { '__kaching_bundles': JSON.stringify(kachingMeta) } };
          return item;
        }

        var payload = { items: [] };

        /* Gifts first */
        if (shippingVariant && giftShippingId) payload.items.push(buildGiftItem(shippingVariant, giftShippingId));
        if (ebookVariant && giftEbookId && (lineQuantity === 2 || lineQuantity === 3)) payload.items.push(buildGiftItem(ebookVariant, giftEbookId));
        if (mysteryVariant && giftMysteryId && lineQuantity === 3) payload.items.push(buildGiftItem(mysteryVariant, giftMysteryId));

        /* Main product */
        var mainKachingMeta = { deal: kachingDeal, main: true, id: bundleInstanceId, bid: mainBid };
        var mainItem = { id: variantId, quantity: lineQuantity, properties: { '__kaching_bundles': JSON.stringify(mainKachingMeta) } };
        payload.items.push(mainItem);

        setAtcLoading(true);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function(response) {
          return response.json().then(function(data) {
            if (!response.ok) { var msg = data.description || data.message || 'Something went wrong. Please try again.'; var err = new Error(msg); err.responseData = data; throw err; }
            return data;
          });
        })
        .then(function() {
          setAtcLoading(false);
        })
        .catch(function(err) {
          setAtcLoading(false);
          showAtcError(err.message || 'Could not add to cart. Please try again.');
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petlab-product-selector-pdp-cats"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* ============ Product Image Carousel ============ */
    var pdpCarousels = document.querySelectorAll('[id^="petlab2-pdp-carousel-"]');
    pdpCarousels.forEach(function(carousel) {
      var slidesContainer = carousel.querySelector('[data-pdp2-carousel-slides]');
      if (!slidesContainer) return;
      var slides = slidesContainer.querySelectorAll('.petlab2-pdp__carousel-slide');
      var totalSlides = slides.length;
      if (totalSlides <= 1) return;

      var currentSlide = 0;
      var progressFill = carousel.querySelector('[data-pdp2-carousel-progress-fill]');
      var thumbButtons = carousel.querySelectorAll('.petlab2-pdp__carousel-thumb');
      var thumbsContainer = carousel.querySelector('[data-pdp2-carousel-thumbs]');
      var thumbPrev = carousel.querySelector('[data-pdp2-thumb-prev]');
      var thumbNext = carousel.querySelector('[data-pdp2-thumb-next]');
      var desktopMq = window.matchMedia('(min-width: 768px)');

      /* Desktop: navigate main image via translateX */
      var thumbOffset = 0;
      var thumbsPerView = 4;

      function updateThumbView() {
        if (!thumbsContainer) return;
        var thumbEls = thumbsContainer.querySelectorAll('.petlab2-pdp__carousel-thumb');
        if (thumbEls.length === 0) return;
        var thumbWidth = thumbEls[0].offsetWidth + 6;
        thumbsContainer.scrollTo({ left: thumbOffset * thumbWidth, behavior: 'smooth' });
      }

      function goToSlide(index) {
        if (index < 0) index = 0;
        if (index >= totalSlides) index = totalSlides - 1;
        currentSlide = index;
        slidesContainer.style.transition = 'transform .45s cubic-bezier(.4,0,.2,1)';
        slidesContainer.style.transform = 'translateX(-' + (index * 100) + '%)';
        thumbButtons.forEach(function(thumb, i) {
          thumb.classList.toggle('petlab2-pdp__carousel-thumb--active', i === index);
        });
        /* Keep active thumb in the visible window of 4 */
        if (index < thumbOffset) {
          thumbOffset = index;
          updateThumbView();
        } else if (index >= thumbOffset + thumbsPerView) {
          thumbOffset = index - thumbsPerView + 1;
          updateThumbView();
        }
      }

      /* Thumbnail click handlers */
      thumbButtons.forEach(function(thumb, i) {
        thumb.addEventListener('click', function() { goToSlide(i); });
      });

      /* Thumbnail strip arrow handlers — shift visible thumbnails + navigate main image */
      if (thumbPrev) {
        thumbPrev.addEventListener('click', function() {
          if (thumbOffset > 0) {
            thumbOffset--;
            updateThumbView();
          }
          if (currentSlide > 0) goToSlide(currentSlide - 1);
        });
      }
      if (thumbNext) {
        thumbNext.addEventListener('click', function() {
          if (thumbOffset < totalSlides - thumbsPerView) {
            thumbOffset++;
            updateThumbView();
          }
          if (currentSlide < totalSlides - 1) goToSlide(currentSlide + 1);
        });
      }

      /* Mobile: progress bar — smooth RAF loop */
      if (progressFill) {
        (function rafLoop() {
          if (!desktopMq.matches) {
            var sw = slidesContainer.scrollWidth;
            var cw = slidesContainer.clientWidth;
            if (sw > cw) {
              var p = (slidesContainer.scrollLeft + cw) / sw;
              progressFill.style.width = (Math.min(Math.max(p, 0), 1) * 100) + '%';
            }
          }
          requestAnimationFrame(rafLoop);
        })();
      }

      /* Handle resize between mobile ↔ desktop */
      function handleResize() {
        if (desktopMq.matches) {
          slidesContainer.scrollLeft = 0;
          goToSlide(currentSlide);
        } else {
          slidesContainer.style.transform = '';
        }
      }
      if (desktopMq.addEventListener) { desktopMq.addEventListener('change', handleResize); }
      else if (desktopMq.addListener) { desktopMq.addListener(handleResize); }

      /* Desktop: swipe on main image */
      var deskTouchStartX = 0;
      slidesContainer.addEventListener('touchstart', function(e) {
        if (desktopMq.matches) deskTouchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      slidesContainer.addEventListener('touchend', function(e) {
        if (!desktopMq.matches) return;
        var diff = deskTouchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) goToSlide(currentSlide + 1);
          else goToSlide(currentSlide - 1);
        }
      });

      /* Initial state */
      if (desktopMq.matches) { goToSlide(0); }
    });

    /* ============ Size Buttons ============ */
    var sizeButtons = document.querySelectorAll('.petlab2-pdp__size-btn');
    var sizeIndexToQuantity = [1, 2, 3];

    sizeButtons.forEach(function(btn, sizeIndex) {
      btn.addEventListener('click', function() {
        sizeButtons.forEach(function(b) { b.classList.remove('petlab2-pdp__size-btn--active'); });
        this.classList.add('petlab2-pdp__size-btn--active');
        var targetQty = sizeIndexToQuantity[sizeIndex];
        if (targetQty == null) return;
        var targetCard = document.querySelector('.petlab2-pdp__qty-card[data-line-item-quantity="' + targetQty + '"]');
        if (targetCard) targetCard.click();
      });
    });

    /* Auto-click the Liquid-selected default size AFTER handlers are bound */
    var defaultSizeBtn = document.querySelector('.petlab2-pdp__size-btn--active');
    if (defaultSizeBtn) defaultSizeBtn.click();

    /* ============ Purchase type toggle ============ */
    var infoWrapper = document.getElementById('petlab2-pdp-info');
    var quantityInput = document.getElementById('petlab2-line-quantity');

 /* ============ Quantity card selection ============ */
    var qtyCards = document.querySelectorAll('.petlab2-pdp__qty-card');
    qtyCards.forEach(function(card) {
      card.addEventListener('click', function() {
        qtyCards.forEach(function(c) {
          c.classList.remove('petlab2-pdp__qty-card--selected');
          var radio = c.querySelector('.petlab2-pdp__radio-outer');
          if (radio) { radio.classList.remove('petlab2-pdp__radio-outer--checked'); radio.innerHTML = ''; }
        });
        this.classList.add('petlab2-pdp__qty-card--selected');
        var radio = this.querySelector('.petlab2-pdp__radio-outer');
        if (radio) { radio.classList.add('petlab2-pdp__radio-outer--checked'); radio.innerHTML = '<div class="petlab2-pdp__radio-inner"></div>'; }
        if (quantityInput) {
          var q = parseInt(this.getAttribute('data-line-item-quantity'), 10);
          if (!isNaN(q) && q > 0) quantityInput.value = q;
        }
        updateGiftCards();
      });
    });

    /* ============ Gift Card Visibility ============ */
    function updateGiftCards() {
      var selectedCard = document.querySelector('.petlab2-pdp__qty-card--selected');
      if (!selectedCard) return;
      var qty = parseInt(selectedCard.getAttribute('data-line-item-quantity'), 10) || 1;
      var giftCards = document.querySelectorAll('[data-gift-min-qty]');
      giftCards.forEach(function(card) {
        var minQty = parseInt(card.getAttribute('data-gift-min-qty'), 10) || 1;
        if (qty >= minQty) {
          card.style.opacity = '1';
          card.style.filter = 'none';
        } else {
          card.style.opacity = '0.35';
          card.style.filter = 'grayscale(100%)';
        }
      });
    }
    updateGiftCards();

    /* ============ Add to Cart Handler ============ */
    var productForm = document.getElementById('petlab2-product-form');
    var atcButton = document.getElementById('petlab2-add-to-cart');

    /* Theme class stripper */
    function stripThemeClasses() {
      if (!atcButton) return;
      var keep = [];
      var classes = atcButton.className.split(/\s+/);
      for (var i = 0; i < classes.length; i++) { var cls = classes[i]; if (cls && cls.indexOf('petlab2-') === 0) keep.push(cls); }
      var newClassName = keep.join(' ');
      if (atcButton.className !== newClassName) atcButton.className = newClassName;
    }
    stripThemeClasses();
    if (atcButton && typeof MutationObserver !== 'undefined') {
      var classObserver = new MutationObserver(function(mutations) { for (var i = 0; i < mutations.length; i++) { if (mutations[i].attributeName === 'class') { stripThemeClasses(); break; } } });
      classObserver.observe(atcButton, { attributes: true, attributeFilter: ['class'] });
    }

    var atcLabel = productForm ? productForm.querySelector('.petlab2-pdp__atc-label') : null;
    var atcSpinner = productForm ? productForm.querySelector('.petlab2-pdp__atc-spinner') : null;
    var atcError = document.getElementById('petlab2-atc-error');
    var variantInput = document.getElementById('petlab2-variant-id');

    function setAtcLoading(isLoading) {
      if (!atcButton) return;
      atcButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      atcButton.disabled = !!isLoading;
      var idleLabel = atcButton.getAttribute('data-atc-idle-label') || 'Add to Cart';
      if (atcLabel) atcLabel.textContent = isLoading ? 'Adding...' : idleLabel;
      if (atcSpinner) { if (isLoading) atcSpinner.removeAttribute('hidden'); else atcSpinner.setAttribute('hidden', ''); }
    }
    function showAtcError(message) { if (!atcError) return; atcError.textContent = message; atcError.removeAttribute('hidden'); }
    function clearAtcError() { if (!atcError) return; atcError.setAttribute('hidden', ''); atcError.textContent = ''; }

    /* bfcache restoration */
    window.addEventListener('pageshow', function(event) { if (event.persisted) { setAtcLoading(false); clearAtcError(); } });

    if (productForm) {
      productForm.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        clearAtcError();

        var selectedCard = document.querySelector('.petlab2-pdp__qty-card--selected');
        var lineQuantity = 1;
        if (selectedCard) { var q = parseInt(selectedCard.getAttribute('data-line-item-quantity'), 10); if (!isNaN(q) && q > 0) lineQuantity = q; }

        var variantId = variantInput ? variantInput.value : '';

        if (!variantId) { showAtcError('Product is not configured. Please contact support.'); return; }

        /* Build Kaching-compatible cart payload */
        var kachingDeal = infoWrapper ? infoWrapper.getAttribute('data-kaching-deal') : '';
        var kachingBidByQty = {
          1: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-1') : '',
          2: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-2') : '',
          3: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-3') : ''
        };
        var giftShippingId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-shipping') : '';
        var giftEbookId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-ebook') : '';
        var giftMysteryId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-mystery') : '';
        var shippingVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-shipping') : '';
        var ebookVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-ebook') : '';
        var mysteryVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-mystery') : '';

        function generateBundleInstanceId() {
          var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
          var out = '';
          for (var i = 0; i < 4; i++) out += chars.charAt(Math.floor(Math.random() * chars.length));
          return out;
        }
        var bundleInstanceId = generateBundleInstanceId();
        var mainBid = kachingBidByQty[lineQuantity] || kachingBidByQty[1];

        function buildGiftItem(giftVariantId, giftId, includeSellingPlan) {
          var kachingMeta = { id: bundleInstanceId, deal: kachingDeal, gift: giftId };
          var item = { id: giftVariantId, quantity: 1, parent_id: parseInt(variantId, 10), properties: { '__kaching_bundles': JSON.stringify(kachingMeta) } };
          if (includeSellingPlan && sellingPlanInt) item.selling_plan = sellingPlanInt;
          return item;
        }

        var payload = { items: [] };

        /* Gifts first */
        if (shippingVariant && giftShippingId) payload.items.push(buildGiftItem(shippingVariant, giftShippingId));
        if (ebookVariant && giftEbookId && (lineQuantity === 2 || lineQuantity === 3)) payload.items.push(buildGiftItem(ebookVariant, giftEbookId, false));
        if (mysteryVariant && giftMysteryId && lineQuantity === 3) payload.items.push(buildGiftItem(mysteryVariant, giftMysteryId, false));

        /* Include checked upsell add-ons in the ATC payload */
        var checkedUpsells = document.querySelectorAll('.petlab2-pdp__upsell-checkbox:checked');
        checkedUpsells.forEach(function(checkbox) {
          var upsellVariantId = checkbox.getAttribute('data-upsell-variant-id');
          if (upsellVariantId) payload.items.push({ id: upsellVariantId, quantity: 1 });
        });

        /* Main product last */
        var mainKachingMeta = { deal: kachingDeal, main: true, id: bundleInstanceId, bid: mainBid };
        var mainItem = { id: variantId, quantity: lineQuantity, properties: { '__kaching_bundles': JSON.stringify(mainKachingMeta) } };
        payload.items.push(mainItem);

        setAtcLoading(true);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function(response) {
          return response.json().then(function(data) {
            if (!response.ok) { var msg = data.description || data.message || 'Something went wrong. Please try again.'; var err = new Error(msg); err.responseData = data; throw err; }
            return data;
          });
        })
        .then(function() {
          setAtcLoading(false);
        })
        .catch(function(err) {
          setAtcLoading(false);
          showAtcError(err.message || 'Could not add to cart. Please try again.');
        });
      });
    }
    /* ============ Product Info Accordion ============ */
    var accordionTriggers = document.querySelectorAll('[data-petlab2-accordion-trigger]');
    accordionTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var content = trigger.nextElementSibling;
        if (!content) return;
        if (expanded) {
          trigger.setAttribute('aria-expanded', 'false');
          content.classList.remove('petlab2-accordion--open');
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          content.classList.add('petlab2-accordion--open');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petlab-product-selector-pdp"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* ============ Product Image Carousel ============ */
    var pdpCarousels = document.querySelectorAll('[id^="petlab2-pdp-carousel-"]');
    pdpCarousels.forEach(function(carousel) {
      var slidesContainer = carousel.querySelector('[data-pdp2-carousel-slides]');
      if (!slidesContainer) return;
      var slides = slidesContainer.querySelectorAll('.petlab2-pdp__carousel-slide');
      var totalSlides = slides.length;
      if (totalSlides <= 1) return;

      var currentSlide = 0;
      var progressFill = carousel.querySelector('[data-pdp2-carousel-progress-fill]');
      var thumbButtons = carousel.querySelectorAll('.petlab2-pdp__carousel-thumb');
      var thumbsContainer = carousel.querySelector('[data-pdp2-carousel-thumbs]');
      var thumbPrev = carousel.querySelector('[data-pdp2-thumb-prev]');
      var thumbNext = carousel.querySelector('[data-pdp2-thumb-next]');
      var desktopMq = window.matchMedia('(min-width: 768px)');

      /* Desktop: navigate main image via translateX */
      var thumbOffset = 0;
      var thumbsPerView = 4;

      function updateThumbView() {
        if (!thumbsContainer) return;
        var thumbEls = thumbsContainer.querySelectorAll('.petlab2-pdp__carousel-thumb');
        if (thumbEls.length === 0) return;
        var thumbWidth = thumbEls[0].offsetWidth + 6;
        thumbsContainer.scrollTo({ left: thumbOffset * thumbWidth, behavior: 'smooth' });
      }

      function goToSlide(index) {
        if (index < 0) index = 0;
        if (index >= totalSlides) index = totalSlides - 1;
        currentSlide = index;
        slidesContainer.style.transition = 'transform .45s cubic-bezier(.4,0,.2,1)';
        slidesContainer.style.transform = 'translateX(-' + (index * 100) + '%)';
        thumbButtons.forEach(function(thumb, i) {
          thumb.classList.toggle('petlab2-pdp__carousel-thumb--active', i === index);
        });
        /* Keep active thumb in the visible window of 4 */
        if (index < thumbOffset) {
          thumbOffset = index;
          updateThumbView();
        } else if (index >= thumbOffset + thumbsPerView) {
          thumbOffset = index - thumbsPerView + 1;
          updateThumbView();
        }
      }

      /* Thumbnail click handlers */
      thumbButtons.forEach(function(thumb, i) {
        thumb.addEventListener('click', function() { goToSlide(i); });
      });

      /* Thumbnail strip arrow handlers — shift visible thumbnails + navigate main image */
      if (thumbPrev) {
        thumbPrev.addEventListener('click', function() {
          if (thumbOffset > 0) {
            thumbOffset--;
            updateThumbView();
          }
          if (currentSlide > 0) goToSlide(currentSlide - 1);
        });
      }
      if (thumbNext) {
        thumbNext.addEventListener('click', function() {
          if (thumbOffset < totalSlides - thumbsPerView) {
            thumbOffset++;
            updateThumbView();
          }
          if (currentSlide < totalSlides - 1) goToSlide(currentSlide + 1);
        });
      }

      /* Mobile: progress bar — smooth RAF loop */
      if (progressFill) {
        (function rafLoop() {
          if (!desktopMq.matches) {
            var sw = slidesContainer.scrollWidth;
            var cw = slidesContainer.clientWidth;
            if (sw > cw) {
              var p = (slidesContainer.scrollLeft + cw) / sw;
              progressFill.style.width = (Math.min(Math.max(p, 0), 1) * 100) + '%';
            }
          }
          requestAnimationFrame(rafLoop);
        })();
      }

      /* Handle resize between mobile ↔ desktop */
      function handleResize() {
        if (desktopMq.matches) {
          slidesContainer.scrollLeft = 0;
          goToSlide(currentSlide);
        } else {
          slidesContainer.style.transform = '';
        }
      }
      if (desktopMq.addEventListener) { desktopMq.addEventListener('change', handleResize); }
      else if (desktopMq.addListener) { desktopMq.addListener(handleResize); }

      /* Desktop: swipe on main image */
      var deskTouchStartX = 0;
      slidesContainer.addEventListener('touchstart', function(e) {
        if (desktopMq.matches) deskTouchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      slidesContainer.addEventListener('touchend', function(e) {
        if (!desktopMq.matches) return;
        var diff = deskTouchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) goToSlide(currentSlide + 1);
          else goToSlide(currentSlide - 1);
        }
      });

      /* Initial state */
      if (desktopMq.matches) { goToSlide(0); }
    });

    /* ============ Size Buttons ============ */
    var sizeButtons = document.querySelectorAll('.petlab2-pdp__size-btn');
    var sizeIndexToQuantity = [1, 2, 3];

    sizeButtons.forEach(function(btn, sizeIndex) {
      btn.addEventListener('click', function() {
        sizeButtons.forEach(function(b) { b.classList.remove('petlab2-pdp__size-btn--active'); });
        this.classList.add('petlab2-pdp__size-btn--active');
        var targetQty = sizeIndexToQuantity[sizeIndex];
        if (targetQty == null) return;
        var targetCard = document.querySelector('.petlab2-pdp__qty-card[data-line-item-quantity="' + targetQty + '"]');
        if (targetCard) targetCard.click();
      });
    });

    /* Auto-click the Liquid-selected default size AFTER handlers are bound */
    var defaultSizeBtn = document.querySelector('.petlab2-pdp__size-btn--active');
    if (defaultSizeBtn) defaultSizeBtn.click();

    /* ============ Purchase type toggle ============ */
    var infoWrapper = document.getElementById('petlab2-pdp-info');
    var quantityInput = document.getElementById('petlab2-line-quantity');

 /* ============ Quantity card selection ============ */
    var qtyCards = document.querySelectorAll('.petlab2-pdp__qty-card');
    qtyCards.forEach(function(card) {
      card.addEventListener('click', function() {
        qtyCards.forEach(function(c) {
          c.classList.remove('petlab2-pdp__qty-card--selected');
          var radio = c.querySelector('.petlab2-pdp__radio-outer');
          if (radio) { radio.classList.remove('petlab2-pdp__radio-outer--checked'); radio.innerHTML = ''; }
        });
        this.classList.add('petlab2-pdp__qty-card--selected');
        var radio = this.querySelector('.petlab2-pdp__radio-outer');
        if (radio) { radio.classList.add('petlab2-pdp__radio-outer--checked'); radio.innerHTML = '<div class="petlab2-pdp__radio-inner"></div>'; }
        if (quantityInput) {
          var q = parseInt(this.getAttribute('data-line-item-quantity'), 10);
          if (!isNaN(q) && q > 0) quantityInput.value = q;
        }
        updateGiftCards();
      });
    });

    /* ============ Gift Card Visibility ============ */
    function updateGiftCards() {
      var selectedCard = document.querySelector('.petlab2-pdp__qty-card--selected');
      if (!selectedCard) return;
      var qty = parseInt(selectedCard.getAttribute('data-line-item-quantity'), 10) || 1;
      var giftCards = document.querySelectorAll('[data-gift-min-qty]');
      giftCards.forEach(function(card) {
        var minQty = parseInt(card.getAttribute('data-gift-min-qty'), 10) || 1;
        if (qty >= minQty) {
          card.style.opacity = '1';
          card.style.filter = 'none';
        } else {
          card.style.opacity = '0.35';
          card.style.filter = 'grayscale(100%)';
        }
      });
    }
    updateGiftCards();

    /* ============ Add to Cart Handler ============ */
    var productForm = document.getElementById('petlab2-product-form');
    var atcButton = document.getElementById('petlab2-add-to-cart');

    /* Theme class stripper */
    function stripThemeClasses() {
      if (!atcButton) return;
      var keep = [];
      var classes = atcButton.className.split(/\s+/);
      for (var i = 0; i < classes.length; i++) { var cls = classes[i]; if (cls && cls.indexOf('petlab2-') === 0) keep.push(cls); }
      var newClassName = keep.join(' ');
      if (atcButton.className !== newClassName) atcButton.className = newClassName;
    }
    stripThemeClasses();
    if (atcButton && typeof MutationObserver !== 'undefined') {
      var classObserver = new MutationObserver(function(mutations) { for (var i = 0; i < mutations.length; i++) { if (mutations[i].attributeName === 'class') { stripThemeClasses(); break; } } });
      classObserver.observe(atcButton, { attributes: true, attributeFilter: ['class'] });
    }

    var atcLabel = productForm ? productForm.querySelector('.petlab2-pdp__atc-label') : null;
    var atcSpinner = productForm ? productForm.querySelector('.petlab2-pdp__atc-spinner') : null;
    var atcError = document.getElementById('petlab2-atc-error');
    var variantInput = document.getElementById('petlab2-variant-id');

    function setAtcLoading(isLoading) {
      if (!atcButton) return;
      atcButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      atcButton.disabled = !!isLoading;
      var idleLabel = atcButton.getAttribute('data-atc-idle-label') || 'Add to Cart';
      if (atcLabel) atcLabel.textContent = isLoading ? 'Adding...' : idleLabel;
      if (atcSpinner) { if (isLoading) atcSpinner.removeAttribute('hidden'); else atcSpinner.setAttribute('hidden', ''); }
    }
    function showAtcError(message) { if (!atcError) return; atcError.textContent = message; atcError.removeAttribute('hidden'); }
    function clearAtcError() { if (!atcError) return; atcError.setAttribute('hidden', ''); atcError.textContent = ''; }

    /* bfcache restoration */
    window.addEventListener('pageshow', function(event) { if (event.persisted) { setAtcLoading(false); clearAtcError(); } });

    if (productForm) {
      productForm.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        clearAtcError();

        var selectedCard = document.querySelector('.petlab2-pdp__qty-card--selected');
        var lineQuantity = 1;
        if (selectedCard) { var q = parseInt(selectedCard.getAttribute('data-line-item-quantity'), 10); if (!isNaN(q) && q > 0) lineQuantity = q; }

        var variantId = variantInput ? variantInput.value : '';

        if (!variantId) { showAtcError('Product is not configured. Please contact support.'); return; }

        /* Build Kaching-compatible cart payload */
        var kachingDeal = infoWrapper ? infoWrapper.getAttribute('data-kaching-deal') : '';
        var kachingBidByQty = {
          1: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-1') : '',
          2: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-2') : '',
          3: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-3') : ''
        };
        var giftShippingId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-shipping') : '';
        var giftEbookId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-ebook') : '';
        var giftMysteryId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-mystery') : '';
        var shippingVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-shipping') : '';
        var ebookVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-ebook') : '';
        var mysteryVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-mystery') : '';

        function generateBundleInstanceId() {
          var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
          var out = '';
          for (var i = 0; i < 4; i++) out += chars.charAt(Math.floor(Math.random() * chars.length));
          return out;
        }
        var bundleInstanceId = generateBundleInstanceId();
        var mainBid = kachingBidByQty[lineQuantity] || kachingBidByQty[1];

        function buildGiftItem(giftVariantId, giftId, includeSellingPlan) {
          var kachingMeta = { id: bundleInstanceId, deal: kachingDeal, gift: giftId };
          var item = { id: giftVariantId, quantity: 1, parent_id: parseInt(variantId, 10), properties: { '__kaching_bundles': JSON.stringify(kachingMeta) } };
          if (includeSellingPlan && sellingPlanInt) item.selling_plan = sellingPlanInt;
          return item;
        }

        var payload = { items: [] };

        /* Gifts first */
        if (shippingVariant && giftShippingId) payload.items.push(buildGiftItem(shippingVariant, giftShippingId));
        if (ebookVariant && giftEbookId && (lineQuantity === 2 || lineQuantity === 3)) payload.items.push(buildGiftItem(ebookVariant, giftEbookId, false));
        if (mysteryVariant && giftMysteryId && lineQuantity === 3) payload.items.push(buildGiftItem(mysteryVariant, giftMysteryId, false));

        /* Include checked upsell add-ons in the ATC payload */
        var checkedUpsells = document.querySelectorAll('.petlab2-pdp__upsell-checkbox:checked');
        checkedUpsells.forEach(function(checkbox) {
          var upsellVariantId = checkbox.getAttribute('data-upsell-variant-id');
          if (upsellVariantId) payload.items.push({ id: upsellVariantId, quantity: 1 });
        });

        /* Main product last */
        var mainKachingMeta = { deal: kachingDeal, main: true, id: bundleInstanceId, bid: mainBid };
        var mainItem = { id: variantId, quantity: lineQuantity, properties: { '__kaching_bundles': JSON.stringify(mainKachingMeta) } };
        payload.items.push(mainItem);

        setAtcLoading(true);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function(response) {
          return response.json().then(function(data) {
            if (!response.ok) { var msg = data.description || data.message || 'Something went wrong. Please try again.'; var err = new Error(msg); err.responseData = data; throw err; }
            return data;
          });
        })
        .then(function() {
          setAtcLoading(false);
        })
        .catch(function(err) {
          setAtcLoading(false);
          showAtcError(err.message || 'Could not add to cart. Please try again.');
        });
      });
    }
    /* ============ Product Info Accordion ============ */
    var accordionTriggers = document.querySelectorAll('[data-petlab2-accordion-trigger]');
    accordionTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var content = trigger.nextElementSibling;
        if (!content) return;
        if (expanded) {
          trigger.setAttribute('aria-expanded', 'false');
          content.classList.remove('petlab2-accordion--open');
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          content.classList.add('petlab2-accordion--open');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petlab-product-selector"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* ============ Product Image Carousel ============ */
    var pdpCarousels = document.querySelectorAll('[id^="petlab-pdp-carousel-"]');
    pdpCarousels.forEach(function(carousel) {
      var slidesContainer = carousel.querySelector('[data-pdp-carousel-slides]');
      var dotsContainer = carousel.querySelector('[data-pdp-carousel-dots]');
      var prevBtn = carousel.querySelector('[data-pdp-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-pdp-carousel-next]');
      if (!slidesContainer) return;
      var slides = slidesContainer.querySelectorAll('.petlab-pdp__carousel-slide');
      var totalSlides = slides.length;
      if (totalSlides === 0) return;
      var currentPdpSlide = 0;
      function goToPdpSlide(index) {
        currentPdpSlide = index;
        slidesContainer.style.transform = 'translateX(-' + (index * 100) + '%)';
        if (dotsContainer) {
          var dots = dotsContainer.querySelectorAll('.petlab-pdp__carousel-dot');
          dots.forEach(function(d, i) { d.classList.toggle('petlab-pdp__carousel-dot--active', i === index); });
        }
      }
      if (dotsContainer && totalSlides > 1) {
        for (var i = 0; i < totalSlides; i++) {
          (function(index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'petlab-pdp__carousel-dot' + (index === 0 ? ' petlab-pdp__carousel-dot--active' : '');
            dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
            dot.addEventListener('click', function() { goToPdpSlide(index); });
            dotsContainer.appendChild(dot);
          })(i);
        }
      }
      if (prevBtn) prevBtn.addEventListener('click', function() { goToPdpSlide((currentPdpSlide - 1 + totalSlides) % totalSlides); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goToPdpSlide((currentPdpSlide + 1) % totalSlides); });
    });

    /* ============ Size Buttons ============ */
    var sizeButtons = document.querySelectorAll('.petlab-pdp__size-btn');
    var sizeIndexToQuantity = [1, 2, 3];

    /* FIX #6: Bind click handlers FIRST, then auto-click the default.
       Previously the auto-click fired before handlers were attached. */
    sizeButtons.forEach(function(btn, sizeIndex) {
      btn.addEventListener('click', function() {
        sizeButtons.forEach(function(b) { b.classList.remove('petlab-pdp__size-btn--active'); });
        this.classList.add('petlab-pdp__size-btn--active');
        var targetQty = sizeIndexToQuantity[sizeIndex];
        if (targetQty == null) return;
        var targetCard = document.querySelector('.petlab-pdp__qty-card[data-line-item-quantity="' + targetQty + '"]');
        if (targetCard) targetCard.click();
      });
    });

    /* Auto-click the Liquid-selected default size AFTER handlers are bound */
    var defaultSizeBtn = document.querySelector('.petlab-pdp__size-btn--active');
    if (defaultSizeBtn) defaultSizeBtn.click();

    /* ============ Purchase type toggle ============ */
    var infoWrapper = document.getElementById('petlab-pdp-info');
    var toggleTrack = document.getElementById('petlab-purchase-toggle');
    var toggleSub = document.getElementById('petlab-toggle-sub');
    var toggleOtp = document.getElementById('petlab-toggle-otp');
    var sellingPlanInput = document.getElementById('petlab-selling-plan');
    var quantityInput = document.getElementById('petlab-line-quantity');

    function setPurchaseType(type) {
      if (!infoWrapper || !toggleTrack) return;
      infoWrapper.setAttribute('data-purchase-type', type);
      toggleTrack.setAttribute('data-active', type === 'subscription' ? 'sub' : 'otp');
      if (toggleSub && toggleOtp) {
        var subActive = type === 'subscription';
        toggleSub.classList.toggle('petlab-pdp__toggle-btn--active', subActive);
        toggleOtp.classList.toggle('petlab-pdp__toggle-btn--active', !subActive);
        toggleSub.setAttribute('aria-selected', subActive ? 'true' : 'false');
        toggleOtp.setAttribute('aria-selected', subActive ? 'false' : 'true');
      }
      /* FIX #5: Clear or restore the selling_plan hidden input */
      if (sellingPlanInput) {
        var defaultPlan = sellingPlanInput.getAttribute('data-default-selling-plan') || '';
        sellingPlanInput.value = (type === 'subscription') ? defaultPlan : '';
      }
      /* Swap price/meta/badge text on every qty card */
      var prefix = type === 'subscription' ? 'sub' : 'onetime';
      var cards = document.querySelectorAll('.petlab-pdp__qty-card');
      cards.forEach(function(card) {
        var salePrice = card.getAttribute('data-' + prefix + '-sale-price') || '';
        var comparePrice = card.getAttribute('data-' + prefix + '-compare-price') || '';
        var meta = card.getAttribute('data-' + prefix + '-meta') || '';
        var discountBadge = card.getAttribute('data-' + prefix + '-discount-badge') || '';
        var urgencyBadge = card.getAttribute('data-' + prefix + '-urgency-badge') || '';
        var saleEl = card.querySelector('[data-slot="sale-price"]');
        var compareEl = card.querySelector('[data-slot="compare-price"]');
        var metaEl = card.querySelector('[data-slot="meta"]');
        var discountEl = card.querySelector('[data-badge-slot="discount"]');
        var urgencyEl = card.querySelector('[data-badge-slot="urgency"]');
        if (saleEl) saleEl.textContent = salePrice;
        if (metaEl) metaEl.textContent = meta;
        if (compareEl) {
          compareEl.textContent = comparePrice;
          var compareWrap = compareEl.closest('.petlab-pdp__qty-compare');
          if (compareWrap) { if (comparePrice) compareWrap.removeAttribute('hidden'); else compareWrap.setAttribute('hidden', ''); }
        }
        if (discountEl) { discountEl.textContent = discountBadge; if (discountBadge) discountEl.removeAttribute('hidden'); else discountEl.setAttribute('hidden', ''); }
        if (urgencyEl) { urgencyEl.textContent = urgencyBadge; if (urgencyBadge) urgencyEl.removeAttribute('hidden'); else urgencyEl.setAttribute('hidden', ''); }
      });
    }

    if (toggleSub) toggleSub.addEventListener('click', function() { setPurchaseType('subscription'); });
    if (toggleOtp) toggleOtp.addEventListener('click', function() { setPurchaseType('onetime'); });
    setPurchaseType('onetime');

    /* ============ Quantity card selection ============ */
    var qtyCards = document.querySelectorAll('.petlab-pdp__qty-card');
    qtyCards.forEach(function(card) {
      card.addEventListener('click', function() {
        qtyCards.forEach(function(c) {
          c.classList.remove('petlab-pdp__qty-card--selected');
          var radio = c.querySelector('.petlab-pdp__radio-outer');
          if (radio) { radio.classList.remove('petlab-pdp__radio-outer--checked'); radio.innerHTML = ''; }
        });
        this.classList.add('petlab-pdp__qty-card--selected');
        var radio = this.querySelector('.petlab-pdp__radio-outer');
        if (radio) { radio.classList.add('petlab-pdp__radio-outer--checked'); radio.innerHTML = '<div class="petlab-pdp__radio-inner"></div>'; }
        /* FIX #4: Keep hidden quantity input in sync */
        if (quantityInput) {
          var q = parseInt(this.getAttribute('data-line-item-quantity'), 10);
          if (!isNaN(q) && q > 0) quantityInput.value = q;
        }
      });
    });

    /* ============ Add to Cart Handler ============ */
    var productForm = document.getElementById('petlab-product-form');
    var atcButton = document.getElementById('petlab-add-to-cart');

    /* Theme class stripper */
    function stripThemeClasses() {
      if (!atcButton) return;
      var keep = [];
      var classes = atcButton.className.split(/\s+/);
      for (var i = 0; i < classes.length; i++) { var cls = classes[i]; if (cls && cls.indexOf('petlab-') === 0) keep.push(cls); }
      var newClassName = keep.join(' ');
      if (atcButton.className !== newClassName) atcButton.className = newClassName;
    }
    stripThemeClasses();
    if (atcButton && typeof MutationObserver !== 'undefined') {
      var classObserver = new MutationObserver(function(mutations) { for (var i = 0; i < mutations.length; i++) { if (mutations[i].attributeName === 'class') { stripThemeClasses(); break; } } });
      classObserver.observe(atcButton, { attributes: true, attributeFilter: ['class'] });
    }

    var atcLabel = productForm ? productForm.querySelector('.petlab-pdp__atc-label') : null;
    var atcSpinner = productForm ? productForm.querySelector('.petlab-pdp__atc-spinner') : null;
    var atcError = document.getElementById('petlab-atc-error');
    var variantInput = document.getElementById('petlab-variant-id');

    function setAtcLoading(isLoading) {
      if (!atcButton) return;
      atcButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      atcButton.disabled = !!isLoading;
      var idleLabel = atcButton.getAttribute('data-atc-idle-label') || 'Add to Cart';
      if (atcLabel) atcLabel.textContent = isLoading ? 'Adding...' : idleLabel;
      if (atcSpinner) { if (isLoading) atcSpinner.removeAttribute('hidden'); else atcSpinner.setAttribute('hidden', ''); }
    }
    function showAtcError(message) { if (!atcError) return; atcError.textContent = message; atcError.removeAttribute('hidden'); }
    function clearAtcError() { if (!atcError) return; atcError.setAttribute('hidden', ''); atcError.textContent = ''; }

    /* bfcache restoration */
    window.addEventListener('pageshow', function(event) { if (event.persisted) { setAtcLoading(false); clearAtcError(); } });

    if (productForm) {
      productForm.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        clearAtcError();

        var selectedCard = document.querySelector('.petlab-pdp__qty-card--selected');
        var lineQuantity = 1;
        if (selectedCard) { var q = parseInt(selectedCard.getAttribute('data-line-item-quantity'), 10); if (!isNaN(q) && q > 0) lineQuantity = q; }

        var purchaseType = infoWrapper ? infoWrapper.getAttribute('data-purchase-type') : 'subscription';
        var defaultSellingPlan = sellingPlanInput ? sellingPlanInput.getAttribute('data-default-selling-plan') : '';
        var variantId = variantInput ? variantInput.value : '';

        if (!variantId) { showAtcError('Product is not configured. Please contact support.'); return; }

        /* Build Kaching-compatible cart payload */
        var kachingDeal = infoWrapper ? infoWrapper.getAttribute('data-kaching-deal') : '';
        var kachingSubPct = parseInt(infoWrapper ? infoWrapper.getAttribute('data-kaching-sub-discount') : '15', 10) || 15;
        var kachingBidByQty = {
          1: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-1') : '',
          3: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-3') : '',
          5: infoWrapper ? infoWrapper.getAttribute('data-kaching-bid-5') : ''
        };
        var giftShippingId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-shipping') : '';
        var giftEbookId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-ebook') : '';
        var giftMysteryId = infoWrapper ? infoWrapper.getAttribute('data-kaching-gift-mystery') : '';
        var shippingVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-shipping') : '';
        var ebookVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-ebook') : '';
        var mysteryVariant = infoWrapper ? infoWrapper.getAttribute('data-freebie-mystery') : '';

        var sellingPlanInt = parseInt(defaultSellingPlan, 10);
        if (isNaN(sellingPlanInt)) sellingPlanInt = 0;

        function generateBundleInstanceId() {
          var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
          var out = '';
          for (var i = 0; i < 4; i++) out += chars.charAt(Math.floor(Math.random() * chars.length));
          return out;
        }
        var bundleInstanceId = generateBundleInstanceId();
        var isSub = (purchaseType === 'subscription');
        var mainBid = kachingBidByQty[lineQuantity] || kachingBidByQty[1];

        function buildGiftItem(giftVariantId, giftId, includeSellingPlan) {
          var kachingMeta = { id: bundleInstanceId, deal: kachingDeal, gift: giftId };
          var item = { id: giftVariantId, quantity: 1, parent_id: parseInt(variantId, 10), properties: { '__kaching_bundles': JSON.stringify(kachingMeta) } };
          if (includeSellingPlan && sellingPlanInt) item.selling_plan = sellingPlanInt;
          return item;
        }

        /* FIX #1: var payload — no longer leaks to global scope */
        var payload = { items: [] };

        /* Gifts first */
        if (shippingVariant && giftShippingId) payload.items.push(buildGiftItem(shippingVariant, giftShippingId, isSub));
        if (ebookVariant && giftEbookId && lineQuantity >= 2) payload.items.push(buildGiftItem(ebookVariant, giftEbookId, false));
        if (mysteryVariant && giftMysteryId && lineQuantity >= 3) payload.items.push(buildGiftItem(mysteryVariant, giftMysteryId, false));

        /* FIX #3: Include checked upsell add-ons in the ATC payload */
        var checkedUpsells = document.querySelectorAll('.petlab-pdp__upsell-checkbox:checked');
        checkedUpsells.forEach(function(checkbox) {
          var upsellVariantId = checkbox.getAttribute('data-upsell-variant-id');
          if (upsellVariantId) payload.items.push({ id: upsellVariantId, quantity: 1 });
        });

        /* Main product last */
        var mainKachingMeta = { deal: kachingDeal, main: true, id: bundleInstanceId, bid: mainBid };
        if (isSub && sellingPlanInt) { mainKachingMeta.sellingPlan = { id: sellingPlanInt, priceAdjustment: { type: 'percentage', value: kachingSubPct } }; }
        var mainItem = { id: variantId, quantity: lineQuantity, properties: { '__kaching_bundles': JSON.stringify(mainKachingMeta) } };
        if (isSub && sellingPlanInt) mainItem.selling_plan = sellingPlanInt;
        payload.items.push(mainItem);

        setAtcLoading(true);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function(response) {
          return response.json().then(function(data) {
            if (!response.ok) { var msg = data.description || data.message || 'Something went wrong. Please try again.'; var err = new Error(msg); err.responseData = data; throw err; }
            return data;
          });
        })
        .then(function() {
          if (atcLabel) atcLabel.textContent = 'Redirecting...';
          window.location.assign('/checkout');
        })
        .catch(function(err) {
          setAtcLoading(false);
          showAtcError(err.message || 'Could not add to cart. Please try again.');
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petlab-review-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var carousels = document.querySelectorAll('[id^="petlab-reviews-"]');

    carousels.forEach(function(carousel) {
      var track = carousel.querySelector('[data-reviews-track]');
      var prevBtn = carousel.querySelector('[data-reviews-prev]');
      var nextBtn = carousel.querySelector('[data-reviews-next]');
      var dotsContainer = carousel.parentElement.querySelector('[data-reviews-dots]');
      if (!track) return;

      var slides = track.querySelectorAll('.petlab-reviews__slide');
      var totalSlides = slides.length;
      if (totalSlides === 0) return;

      function getSlidesPerView() {
        return window.innerWidth >= 1024 ? 2 : 1;
      }

      var currentIndex = 0;

      function totalPages() {
        var per = getSlidesPerView();
        return Math.max(1, totalSlides - per + 1);
      }

      function clampIndex(idx) {
        var max = totalPages() - 1;
        if (idx < 0) return max;
        if (idx > max) return 0;
        return idx;
      }

      function goToIndex(idx) {
        currentIndex = clampIndex(idx);
        var targetSlide = slides[currentIndex];
        if (!targetSlide) return;
        track.style.transform = 'translateX(-' + targetSlide.offsetLeft + 'px)';
        updateDots();
      }

      function buildDots() {
        if (!dotsContainer) return;
        dotsContainer.innerHTML = '';
        var pages = totalPages();
        if (pages <= 1) return;
        for (var i = 0; i < pages; i++) {
          (function(index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'petlab-reviews__dot' + (index === currentIndex ? ' petlab-reviews__dot--active' : '');
            dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
            dot.addEventListener('click', function() { goToIndex(index); });
            dotsContainer.appendChild(dot);
          })(i);
        }
      }

      function updateDots() {
        if (!dotsContainer) return;
        var dots = dotsContainer.querySelectorAll('.petlab-reviews__dot');
        dots.forEach(function(d, i) {
          d.classList.toggle('petlab-reviews__dot--active', i === currentIndex);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() { goToIndex(currentIndex - 1); });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() { goToIndex(currentIndex + 1); });
      }

      var resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          currentIndex = clampIndex(currentIndex);
          buildDots();
          goToIndex(currentIndex);
        }, 150);
      });

      buildDots();
      goToIndex(0);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
